/**
 * Source unique des adresses publiques de Qualneo. Aucune autre source du
 * frontend n'écrit ces adresses en dur (garde : `contact-source-guard.test.ts`).
 * Côté serveur, l'équivalent vit dans `src/config/contact.rs`.
 */

/** Assistance aux utilisateurs. */
export const SUPPORT_EMAIL = "support@qualneo.fr"

/** Demandes commerciales (changement de plan, etc.). */
export const CONTACT_EMAIL = "contact@qualneo.fr"

/** Référent protection des données, comme dans la politique de confidentialité. */
export const DPO_EMAIL = "dpo@qualneo.fr"
